export class LogsSchemaColumn {
    'name';
    'type';
    'values';
    '_private';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "values",
            "baseName": "values",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "_private",
            "baseName": "private",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogsSchemaColumn.attributeTypeMap;
    }
    constructor() {
    }
}
